/**
 * accordion-content
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module template
import './_accordion-content.css';
import './_accordion-content.twig';

export const name = 'accordion-content';

export const defaults = {
  dummyClass: 'js-accordion-content-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { accordionContent = {} }) {
  // Find our component within the DOM
  const $accordionContent = $('.accordion-content', $context);
  // Bail if component does not exist
  if (!$accordionContent.length) {
    return;
  }
  // Merge defaults with incoming settings
  const settings = {
    ...defaults,
    ...accordionContent,
  };
  // An example of what could be done with this component
  $accordionContent.addClass(settings.dummyClass);

  $accordionContent.each(function accordionIterate() {
    // Hides the content.
    $('.accordion__content__content', this).hide();

    // Adds trigger click handler to open and close content.
    $('.accordion__content__title', this).click(
      function accordionTriggerHandler(e) {
        e.preventDefault();

        $(this)
          .parent()
          .toggleClass('accordion__content--opened')
          .children('.accordion__content__content')
          .slideToggle('down');
      }
    );
  });
}

export default enable;
